// extracted by mini-css-extract-plugin
export default {"header":"AppropriatenessModal_header__hPGnR","messageBody":"AppropriatenessModal_messageBody__ytMyh","logoutBtn":"AppropriatenessModal_logoutBtn__PRJ1a"};